import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import BobLoadingMask from '../../../components/BobLoadingMask';
import SensorDataTimestampFilter from '../../../containers/Modals/SensorDataTimestampFilter';
import { getTimeZoneAbbr } from '../../../helpers/timezones';
import * as BobActions from '../../../actions/bobActions';
import * as sensorDataActions from '../../../actions/sensorDataActions';
import * as DeviceActions from '../../../actions/deviceActions';

import Button from '@material-ui/core/Button';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { func, object } from 'prop-types';

import classes from '../CreateEntityModal.module.css';
import aClasses from './PreviewSensorDataModal.module.css';

const PreviewSensorDataModal = ({
    bobLoading,
    clearSensorData,
    deviceObjects,
    fetchSensorData,
    onClose,
    sensor,
    sensorData,
}) => {
    const [data, setData] = useState([]);
    const [startTimestamp, setStartTimestamp] = useState(new moment().add(-4, 'h'));
    const [endTimestamp, setEndTimestamp] = useState(new moment());

    useEffect(() => {
        const init = async () => {
            if (sensor && sensor.id) {
                clearSensorData();

                const deviceObject = deviceObjects ? deviceObjects.find(d => d.id === sensor.deviceObjectId) : null;
                const pollingInterval = deviceObject ? deviceObject.sampleInterval : 15;

                fetchSensorData(
                    {
                        sensorId:       sensor.id,
                        startTimestamp: startTimestamp.toISOString(),
                        endTimestamp:   endTimestamp.toISOString()
                    },
                    pollingInterval
                );
            }
        };
        if ((sensor && sensor.id) && (startTimestamp || endTimestamp)) init();
    }, [sensor, startTimestamp, endTimestamp]);

    useEffect(() => {
        if (sensorData.items) {
            setData(sensorData.items);
        }
        else {
            setData([]);
        }
    }, [sensorData]);

    const handleClose = () => {
        clearSensorData();
        onClose();
    };

    const renderTimestamp = props => {
        const zone = moment.tz.guess();
        return (
            <td>
                <div>{moment(props.dataItem.timestamp).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(props.dataItemtimestamp), zone)}</div>
            </td>
        );
    };

    const renderRawValue = props => {
        if (props.dataItem.rawValue === null) {
            return (<td>No Data</td>);
        }
        else if (props.dataItem.rawUnit) {
            return (
                <td style={{textTransform: 'capitalize'}}>{`${props.dataItem.rawValue} (${props.dataItem.rawUnit})`}</td>
            );
        }
        else {
            return (<td style={{textTransform: 'capitalize'}}>{props.dataItem.rawValue}</td>);
        }
    };

    const renderDisplayValue = props => {
        if (props.dataItem.convertedValue === null) {
            return (<td>No Data</td>);
        }
        else if (typeof(props.dataItem.convertedValue) === 'boolean' && props.dataItem.presentationUnit) {
            return (
                <td style={{textTransform: 'capitalize'}}>{`${props.dataItem.convertedValue.toString()} (${props.dataItem.presentationUnit})`}</td>
            );
        }
        else if (typeof (props.dataItem.convertedValue) === 'boolean') {
            return (
                <td style={{textTransform: 'capitalize'}}>{`${props.dataItem.convertedValue.toString()}`}</td>
            );
        }
        else if (props.dataItem.presentationUnit) {
            return (
                <td style={{textTransform: 'capitalize'}}>{`${props.dataItem.convertedValue} (${props.dataItem.presentationUnit})`}</td>
            );
        }
        else {
            return (<td style={{textTransform: 'capitalize'}}>{props.dataItem.convertedValue}</td>);
        }

    };

    const handleFilterChange = (filterName, value) => {
        if (value) {
            if (filterName === 'startTimestamp') {
                setStartTimestamp(value);
                setEndTimestamp(new moment(value).add(4, 'h'));
            }
            else {
                setEndTimestamp(value);
                setStartTimestamp(new moment(value).add(-4, 'h'));
            }
        }
    };

    return (
        <React.Fragment>
            <div>
                <SensorDataTimestampFilter
                    endTimestamp={endTimestamp}
                    onFilterChange={handleFilterChange}
                    startTimestamp={startTimestamp}
                />
            </div>
            <div className={aClasses.Table}>
                <Grid
                    className={aClasses.KendoGrid}
                    data={data}
                >
                    {
                        bobLoading.includes('PreviewSensorData') ?
                            <GridNoRecords>
                                Loading sensors data
                            </GridNoRecords>
                            :
                            null
                    }
                    <GridColumn
                        title={'TimeStamp'}
                        field={'timestamp'}
                        width={250}
                        cell={renderTimestamp}
                    />
                    <GridColumn
                        title={'Raw Value'}
                        field={'rawValue'}
                        width={265}
                        cell={renderRawValue}
                    />
                    <GridColumn
                        title={'Display Value'}
                        field={'convertedValue'}
                        width={265}
                        cell={renderDisplayValue}
                    />
                </Grid>
            </div>
            <div style={{paddingTop: '15px'}}>
                <Button
                    className={classes.Button}
                    onClick={handleClose}
                    variant="outlined"
                >
                    Close
                </Button>
            </div>
            { bobLoading.includes('PreviewSensorData') ?
                <BobLoadingMask />
                : null
            }
        </React.Fragment>
    );
};

PreviewSensorDataModal.defaultProps = {
    clearSensorData: () => {},
    sensorData:      () => {},
    fetchSensorData: () => {}
};

PreviewSensorDataModal.propTypes = {
    clearSensorData: () => {},
    fetchSensorData: func,
    sensorData:      object
};


export const mapStateToProps = ({ sensorData, ...state}) => ({
    bobLoading:    state.bob.bobLoading,
    deviceObjects: state.device.deviceObjects,
    sensorData
    
});

const mapDispatchToProps = {
    ...BobActions,
    ...DeviceActions,
    ...sensorDataActions
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewSensorDataModal);
